import { useNavigate } from 'react-router-dom';
import { CollaboratorPublic, useCollaboratorsPublicQuery } from '@/features/Collaborators/Data';
import { useCollaboratorFilter } from '@/hooks/useCollaboratorFilter';
import CollaboratorFilters from '@/features/Collaborators/List/Filters/CollaboratorFilters';
import CollaboratorDirectoryTableView from '@/features/Collaborators/List/Contexts/GeneralManagement/CollaboratorDirectoryTableView';

export default function CollaboratorsDirectoryPage() {
    const navigate = useNavigate();
    const { data: collaborators, isLoading, error } = useCollaboratorsPublicQuery();

    // Convertendo CollaboratorPublic para Collaborator para compatibilidade com useCollaboratorFilter
    const collaboratorCompatible = collaborators.map(collab => ({
        ...collab,
        // Campos necessários para compatibilidade que não existem em CollaboratorPublic
        collaboratorType: undefined,
        resources: collab.resources || []
    }));

    const { filteredCollaborators, nameSearchQuery, setNameSearchQuery } = useCollaboratorFilter(collaboratorCompatible);

    const handleEdit = (collaboratorId: string) => {
        navigate(`/collaborators/updates`);
    };

    if (isLoading) {
        return <div>Carregando dados...</div>;
    }

    if (error) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="text-center">
                    <div className="text-red-500 text-lg font-medium mb-2">
                        Erro ao carregar dados
                    </div>
                    <div className="text-gray-600 text-sm">
                        {error.message || 'Ocorreu um erro inesperado. Tente recarregar a página.'}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="space-y-6">
            <CollaboratorFilters
                nameSearchQuery={nameSearchQuery}
                onNameSearchChange={(e) => setNameSearchQuery(e.target.value)}
                onOpenAdvancedFilters={() => { }} // Removido - não será exibido
                showAdvancedFilters={false}
                showColumnSelector={false}
                showStatusFilter={false}
            />

            <CollaboratorDirectoryTableView
                collaborators={filteredCollaborators as CollaboratorPublic[]}
                isLoading={isLoading}
                nameSearchQuery={nameSearchQuery}
                showActions={false}
            />
        </div>
    );
} 